import { FormGroup } from '@angular/forms';

export class AppUtils {
  public static getFormErrors(theForm: FormGroup, formErrors: any): any {
    for (const field in formErrors) {
      if (!formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      formErrors[field] = {};

      // Get the control
      const control = theForm.get(field);

      if (control && control.dirty && !control.valid) {
        formErrors[field] = control.errors;
      }
    }

    return formErrors;
  }
  public static getInvalidFields(theForm: FormGroup, formErrors: any) {
    for (const field in formErrors) {
      if (!formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      formErrors[field] = {};

      // Get the control
      const control = theForm.get(field);

      if (control && control.invalid) {
        formErrors[field] = control.errors;
      }
    }
    return formErrors;
  }
  public static getFormHasValue(theForm: FormGroup, formErrors: any): any {
    for (const field in formErrors) {
      if (!formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      formErrors[field] = {};

      // Get the control
      const control = theForm.get(field);
      if (control && control.value) {
        return true;
      }
    }
    return false;
  }

  public static getActiveItems(itemList: Array<any>): Array<any> {
    const onlyActiveItems: any[] = [];

    itemList.forEach(item => {
      if (item.active) {
        onlyActiveItems.push(item);
      }
    });

    return onlyActiveItems;
  }

  public static getSortOrder(key: any): any {
    switch (key) {
      case 'ascend':
        return 1;
      case 'descend':
        return -1;
      default:
        return -1;
    }
  }

  public static getSortOrderOfLiveOrders(key: any): any {
    switch (key) {
      case 'ascend':
        return 1;
      case 'descend':
        return -1;
      default:
        return 1;
    }
  }
  public static getUrlExtension(name: any): any {
    // const urlParts = url.split('/');
    // const fileNameParts = urlParts[urlParts.length - 1].split('.');
    const fileNameParts = name.split('.');
    return fileNameParts[fileNameParts.length - 1].toLowerCase();
  }
  public static sentenceCase(str: any): any {
    if (str === null || str === '') return false;
    else {
      str = str.replace('_', ' ');
      str = str.toString();
    }
    return str.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
